<template>
  <div class="process-container">
    <div class="process-header">
      <h2>贷款申请流程</h2>
      <p class="subtitle">便捷高效的申请流程，助您快速获取资金支持</p>
    </div>
    <!-- 流程步骤展示区域 -->
    <div class="process-flow">
      <!-- 第一步：预填信息 -->
      <div class="process-step">
        <div class="step-number">1</div>
        <div class="step-content">
          <div class="step-icon">
            <i class="el-icon-edit-outline"></i>
          </div>
          <h3>预填信息</h3>
          <p>预填企业及法定代表人或者实际控制人的基本信息，并选取意向产品</p>
          <div class="step-detail">
            <ul>
              <li>填写企业基本信息</li>
              <li>填写法定代表人信息</li>
              <li>选择适合的贷款产品</li>
              <li>提交初步申请</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="process-arrow">
        <i class="el-icon-arrow-right"></i>
      </div>
      <!-- 第二步：下载资料 -->
      <div class="process-step">
        <div class="step-number">2</div>
        <div class="step-content">
          <div class="step-icon">
            <i class="el-icon-download"></i>
          </div>
          <h3>下载资料</h3>
          <p>下载开户及签约资料</p>
          <div class="step-detail">
            <ul>
              <li>下载开户申请表</li>
              <li>下载贷款合同模板</li>
              <li>下载担保资料清单</li>
              <li>准备相关证明材料</li>
            </ul>
            <!-- <el-button type="primary" size="small" class="download-btn">
              <i class="el-icon-download"></i> 下载资料包
            </el-button> -->
          </div>
        </div>
      </div>

      <div class="process-arrow">
        <i class="el-icon-arrow-right"></i>
      </div>
      <!-- 第三步：预约网点 -->
      <div class="process-step">
        <div class="step-number">3</div>
        <div class="step-content">
          <div class="step-icon">
            <i class="el-icon-date"></i>
          </div>
          <h3>预约网点</h3>
          <p>选择就近网点进行预约</p>
          <div class="step-detail">
            <ul>
              <li>选择服务网点</li>
              <li>选择预约日期和时间</li>
              <li>填写预约联系方式</li>
              <li>获取预约确认</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="process-arrow">
        <i class="el-icon-arrow-right"></i>
      </div>
      <!-- 第四步：现场办理 -->
      <div class="process-step">
        <div class="step-number">4</div>
        <div class="step-content">
          <div class="step-icon">
            <i class="el-icon-office-building"></i>
          </div>
          <h3>现场办理</h3>
          <p>携带相关资料前往预约网点现场办理</p>
          <div class="step-detail">
            <ul>
              <li>携带企业证照原件</li>
              <li>携带法人身份证明</li>
              <li>提交填写完整的申请资料</li>
              <li>签署相关协议</li>
              <li>等待审批结果</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="process-tips">
      <h3><i class="el-icon-info"></i> 办理提示</h3>
      <div class="tips-content">
        <p>1. 请确保填写的企业及个人信息真实有效，以免影响审批进度</p>
        <p>2. 下载的资料请按要求填写完整，并准备好相关证明材料原件及复印件</p>
        <p>3. 预约成功后，请按时前往网点办理，如需变更预约请提前联系</p>
        <p>4. 现场办理时，请法定代表人本人携带有效身份证件前往</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Process",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.process-container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 20px;
}

.process-header {
  text-align: center;
  margin-bottom: 40px;
}

.process-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  font-size: 16px;
}

.process-flow {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.process-step {
  width: 260px;
  position: relative;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  padding-top: 45px;
  height: 320px;
  box-sizing: border-box;
  margin: 10px;
  transition: all 0.3s ease;
}

.process-step:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.step-number {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 30px;
  background: #67c23a;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}

.step-content {
  text-align: center;
}

.step-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  background: #f8f0f0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-icon i {
  font-size: 28px;
  color: #67c23a;
}

.step-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.step-content p {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}

.step-detail ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

.step-detail li {
  margin-bottom: 5px;
  color: #666;
  font-size: 14px;
}

.download-btn {
  background: #67c23a;
  border-color: #67c23a;
}

.download-btn:hover {
  background: #a01818;
  border-color: #a01818;
}

.process-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  margin: 0 -10px;
  margin-top: 100px;
}

.process-arrow i {
  font-size: 24px;
  color: #67c23a;
}

.process-tips {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-top: 30px;
}

.process-tips h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.process-tips h3 i {
  color: #67c23a;
  margin-right: 8px;
}

.tips-content p {
  margin-bottom: 10px;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
</style>